import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { MODELER_SERVICE } from '@eggplant/api-hosts'
import { useGetParamsWithSpaceId } from '../useGetParamsWithSpaceId'
import type {
  GetScriptedTestCasesResponse,
  GetTestCasesParams
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  onSuccess?: (response: GetScriptedTestCasesResponse) => void
  params?: GetTestCasesParams
  children?: (response: GetScriptedTestCasesResponse) => ReactElement
}

const GetModelerScriptTestCasesRequest = ({
  onSuccess,
  params,
  children
}: Props) => {
  const url = `${MODELER_SERVICE}/test_cases/scripted`

  const { requestParams } = useGetParamsWithSpaceId<GetTestCasesParams | undefined>(params)

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onSuccess={onSuccess}
      params={requestParams}
      url={url}
    />
  )
}

export default GetModelerScriptTestCasesRequest
